export default __webpack_public_path__ + "static/qatar-9ffe116a1e221468cdd4e513ca3621de.svg";